import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import { Box } from '@mui/system'
import { useRef, useState } from 'react'
import { convertFileToBase64 } from '../../utils/maks'
import { Base } from './base'
import { Camera } from './camera'
import { useTranslation } from 'react-i18next'

interface Props {
    open: boolean
    handleClose(v: boolean): void
    maxSize: number
    fileTypes: string
    getFile(file: File, content: string): void
}

enum Steps {
    Base = 1,
    Camera = 2,
}

export const FileSelection = ({
    open,
    handleClose,
    fileTypes,
    maxSize,
    getFile,
}: Props) => {
    const { t } = useTranslation()
    const [step, setStep] = useState(Steps.Base)
    const fileRef = useRef<HTMLInputElement>(null)

    const validateFile = async (file: File) => {
        try {
            if (file.size > maxSize) return
            if (!file.type || !fileTypes.includes(file.type)) return
            const base64 = await convertFileToBase64(file)
            getFile(file, base64)
        } catch (error) {}
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={() => handleClose(false)}
                className="modal"
            >
                <DialogTitle>
                    <Box
                        sx={{
                            color: 'text.primary',
                            fontSize: '20px',
                            fontWeight: '500',
                            textAlign: 'center',
                            borderBottom: '1px solid rgba(218, 218, 218, 0.7)',
                            paddingBottom: '10px',
                            minWidth: { xs: 'auto', sm: '350px' },
                        }}
                    >
                        {t('Seleccione uma imagen')}
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ overflow: 'hidden' }}>
                    {step === Steps.Base && (
                        <Base
                            clickSelectFile={() => fileRef.current?.click()}
                            getDroppedFile={(file: File) => validateFile(file)}
                            clickCamera={() => setStep(Steps.Camera)}
                        />
                    )}
                    {step === Steps.Camera && (
                        <Camera
                            goBack={() => setStep(Steps.Base)}
                            returnPhoto={getFile}
                        />
                    )}
                </DialogContent>
            </Dialog>
            <input
                type="file"
                style={{ display: 'none' }}
                ref={fileRef}
                accept={fileTypes}
                onChange={(e) => {
                    if (!e.target.files || !fileRef.current) return
                    const file = e.target.files[0]
                    validateFile(file)
                    fileRef.current.value = ''
                }}
            />
        </>
    )
}
